import React from 'react';

/**
 * @returns {JSX.Element} VodaPayClubTicket svg
 */
export default function MoneyIcon() {
  return (
    <svg
      width='75'
      height='75'
      viewBox='0 0 36 41'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_20872_27894)'>
        <g clipPath='url(#clip1_20872_27894)'>
          <path
            d='M3.58398 24.5945L32.232 24.0848L32.5862 39.4879L3.78172 40.226L3.58398 24.5945Z'
            fill='#A1A3A5'
          />
          <path
            d='M5.20215 26.4534L30.6071 26.0009L30.8715 37.7728L5.32798 38.4284L5.20215 26.4534Z'
            fill='#108846'
          />
          <path
            d='M32.4684 36.3393L3.76007 37.0763L3.68182 30.861L3.56445 21.4977L28.9525 21.0452L32.1162 20.9891L32.4684 36.3393Z'
            fill='#DADBDB'
          />
          <path
            d='M5.17676 23.3458L30.495 22.8954L30.7583 34.6272L5.30153 35.2796L5.17676 23.3458Z'
            fill='#108846'
          />
          <path
            d='M4.75195 17.7106L33.3016 17.202L33.6559 32.5544L4.94863 33.2903L4.75195 17.7117V17.7106Z'
            fill='#EDEDEE'
          />
          <path
            d='M6.36328 19.5626L31.6816 19.1122L31.947 30.845L6.49017 31.4975L6.36328 19.5626Z'
            fill='#57DC7F'
          />
          <path
            d='M26.9102 26.6872C27.68 27.0235 28.5767 26.6714 28.9129 25.9016C29.2492 25.1318 28.8971 24.2351 28.1273 23.8978C27.3575 23.5616 26.4598 23.9137 26.1235 24.6835C25.7873 25.4532 26.1394 26.3499 26.9092 26.6862L26.9102 26.6872Z'
            fill='#A1F190'
          />
          <path
            d='M19.1215 26.1466L18.2385 26.1698L18.3009 28.4771L17.1907 28.5056L17.0215 22.2046L19.0221 22.1507C19.6586 22.1327 20.1535 22.285 20.5077 22.6086C20.8619 22.9311 21.047 23.3953 21.0639 24.0022C21.0861 24.3744 21.0142 24.7466 20.8545 25.0839C20.6948 25.3842 20.4495 25.6295 20.1492 25.7902L21.379 28.3333V28.3935L20.1873 28.4305L19.1225 26.1466H19.1215ZM18.21 25.1188L19.1056 25.0913C19.2251 25.0955 19.3446 25.0733 19.4545 25.0279C19.5645 24.9824 19.6639 24.9126 19.7453 24.8248C19.9018 24.6303 19.9779 24.3829 19.9568 24.1333C19.9642 23.8806 19.8817 23.6332 19.722 23.4376C19.6353 23.3508 19.5296 23.2842 19.4133 23.243C19.297 23.2018 19.1733 23.187 19.0506 23.2007L18.1582 23.2303L18.21 25.1199V25.1188Z'
            fill='#E60000'
            stroke='#E60000'
            strokeWidth='0.25589'
            strokeMiterlimit='10'
          />
          <path
            d='M10.5264 26.8326C11.2962 27.1689 12.1929 26.8168 12.5291 26.047C12.8654 25.2772 12.5133 24.3806 11.7435 24.0443C10.9737 23.7081 10.0771 24.0602 9.73975 24.83C9.4035 25.5997 9.75561 26.4964 10.5254 26.8337L10.5264 26.8326Z'
            fill='#108846'
          />
          <path
            d='M30.398 24.5459C30.398 24.5459 21.2409 27.5584 16.7438 28.4382C13.1011 29.1509 6.18362 30.4071 3.68288 30.8596L3.56445 21.4964L28.9536 21.0438L30.398 24.5459Z'
            fill='#108846'
          />
          <path
            d='M30.3784 24.5459C30.3784 24.5459 21.2214 27.5584 16.7243 28.4382C13.0816 29.1509 6.16409 30.4071 3.66335 30.8596L3.54492 21.4964L28.934 21.0438L30.3784 24.5459Z'
            fill='#A1A3A5'
          />
          <path
            d='M30.4176 24.5464C30.4176 24.5464 21.2605 27.5589 16.7623 28.4387C13.6113 29.0552 8.00606 30.0787 4.93432 30.637L4.77148 17.7114L27.4315 17.3075L30.4176 24.5464Z'
            fill='#108846'
          />
          <path
            d='M6.36448 19.5619L6.47868 30.3526C5.9098 30.4562 5.38322 30.5524 4.91479 30.637L4.75195 17.7114L27.4119 17.3075L28.1817 19.1738L6.36448 19.5619Z'
            fill='#DADBDB'
          />
          <path
            d='M20.969 25.1375C21.1382 24.7823 21.2154 24.3868 21.1911 23.9977C21.1731 23.3569 20.9722 22.8578 20.5937 22.5142C20.2162 22.1695 19.6854 22.0066 19.0182 22.0235L16.8896 22.0796L17.0588 28.3753C17.4797 28.2875 17.9365 28.1849 18.4176 28.0686L18.37 26.2943L19.0414 26.2763L19.7234 27.7398C20.1601 27.6266 20.6074 27.5061 21.061 27.3803L20.3156 25.8407C20.5905 25.6694 20.8147 25.4294 20.969 25.1375ZM19.6526 24.7378C19.5849 24.8108 19.4993 24.8711 19.4062 24.9091C19.3121 24.9483 19.2138 24.9673 19.1028 24.9631L18.3351 24.9863L18.2907 23.3527L19.0647 23.3273C19.1673 23.3157 19.273 23.3283 19.3713 23.3632C19.4665 23.3971 19.5553 23.4521 19.6272 23.5229C19.7647 23.6942 19.8366 23.9099 19.8302 24.1288V24.1362V24.1436C19.8482 24.3614 19.7837 24.5739 19.6526 24.7378Z'
            fill='#AA0000'
          />
          <path
            d='M29.012 24.9943C28.2623 25.2344 27.2589 25.5505 26.1254 25.8984C25.9615 25.5241 25.9498 25.0863 26.1254 24.6835C26.4616 23.9137 27.3583 23.5616 28.1291 23.8978C28.6028 24.104 28.9179 24.5238 29.012 24.9943Z'
            fill='#57DC7F'
          />
          <path
            d='M1.54297 16.5835C1.54297 16.5835 9.26196 14.1071 14.3554 11.5915C19.4489 9.07705 26.0048 0.313354 26.0048 0.313354L32.9603 14.1229C32.9603 14.1229 24.8279 22.8591 14.7763 26.9259C6.97481 30.0822 2.57499 30.9694 2.57499 30.9694L1.54297 16.5835Z'
            fill='#EDEDEE'
          />
          <path
            d='M3.42773 17.6993C3.42773 17.6993 10.1655 15.9609 14.8603 13.1726C20.2445 9.97394 25.9672 2.94226 25.9672 2.94226L31.0025 13.1239C31.0025 13.1239 23.9782 20.5056 16.0805 24.2752C12.0899 26.1743 4.36776 28.4297 4.36776 28.4297L3.42879 17.7003L3.42773 17.6993Z'
            fill='#57DC7F'
          />
          <path
            d='M25.0309 13.5927C25.7224 12.8462 25.7816 11.7793 25.1652 11.2083C24.5487 10.6373 23.4892 10.7801 22.7977 11.5255C22.1072 12.2721 22.0459 13.339 22.6634 13.91C23.2799 14.4809 24.3404 14.3382 25.0309 13.5927Z'
            fill='#108846'
          />
          <path
            d='M16.8486 18.6002L16.0016 19.0178L16.7524 20.882L15.7013 21.3695L13.6934 16.3754L15.5459 15.3688C16.1539 15.0378 16.6847 14.9152 17.1352 15.0029C17.5856 15.0907 17.9208 15.3889 18.1259 15.8901C18.2676 16.2084 18.311 16.5615 18.2518 16.9041C18.1724 17.252 18.0033 17.5724 17.7601 17.8325L19.8156 19.3964L19.8357 19.4461L18.6187 20.0118L16.8486 18.6002ZM15.6601 18.173L16.5134 17.7405C16.7534 17.6369 16.9491 17.4529 17.0664 17.2192C17.1129 17.1124 17.1373 16.9972 17.1362 16.8809C17.1362 16.7645 17.1108 16.6493 17.0622 16.5435C17.0273 16.4378 16.9691 16.3416 16.893 16.2623C16.8158 16.1819 16.7217 16.1206 16.6181 16.0815C16.4214 16.017 16.1803 16.0614 15.8948 16.2126L15.0532 16.6588L15.6601 18.173Z'
            fill='#E60000'
            stroke='#E60000'
            strokeWidth='0.25589'
            strokeMiterlimit='10'
          />
          <path
            d='M8.13867 22.7037C8.90845 23.04 9.80511 22.6879 10.1414 21.9181C10.4776 21.1483 10.1255 20.2517 9.35572 19.9154C8.58595 19.5792 7.68928 19.9313 7.35303 20.701C7.01678 21.4708 7.36889 22.3675 8.13867 22.7037Z'
            fill='#108846'
          />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_20872_27894'>
          <rect
            width='35.2'
            height='40'
            fill='white'
            transform='translate(0 0.270386)'
          />
        </clipPath>
        <clipPath id='clip1_20872_27894'>
          <rect
            width='32.1131'
            height='39.9135'
            fill='white'
            transform='translate(1.54297 0.313354)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
